import { render, staticRenderFns } from "./Form-password-recovery.vue?vue&type=template&id=6ac8b68e&"
import script from "./Form-password-recovery.vue?vue&type=script&lang=js&"
export * from "./Form-password-recovery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports